<template>
  <transition-group name="modal">
    <div class="modal-mask" :key="'mask'" @click.once="emit('closeModal')">
      <div class="modal-container" @click.stop.prevent>
        <div class="modal-body flex flex-wrap justify-center">
          <div class="flex justify-center flex-col">
            <slot name="body">
              <h3 class="pb-4">
                {{ ta('logout_hp_confirm') }}
              </h3>
              <button
                class="btn btn-novacair-selected"
                @click="emit('confirmLogout')"
              >
                {{ ta('do_logout_hp') }}
              </button>
            </slot>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-novacair-light" @click="emit('closeModal')">
            {{ ta('exit.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script setup>
import { adminI18n } from '@/i18n';

function ta(key) {
  return adminI18n.t(key);
}

const emit = defineEmits(['closeModal', 'confirmLogout']);
</script>

<style scoped lang="scss">
@import '@/assets/modal.scss';

.modal-container {
  position: relative;
  width: 50%;
}
</style>
